import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderOld: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderOldGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholder: {
		id: 'projects-directory-v3.page-layout.refinement-bar.search-control.placeholder',
		defaultMessage: 'Search projects',
		description: 'Placeholder label for the Search projects field',
	},
	placeholderOld: {
		id: 'projects-directory-v3.page-layout.refinement-bar.search-control.placeholder-old',
		defaultMessage: 'Search Projects',
		description: 'Placeholder label for the Search Projects field',
	},
	placeholderGalaxia: {
		id: 'projects-directory-v3.page-layout.refinement-bar.search-control.placeholder-galaxia',
		defaultMessage: 'Search spaces',
		description: 'Placeholder label for the Search projects field',
	},
	placeholderOldGalaxia: {
		id: 'projects-directory-v3.page-layout.refinement-bar.search-control.placeholder-old-galaxia',
		defaultMessage: 'Search spaces',
		description: 'Placeholder label for the Search Projects field',
	},
});
export default messages;
